<template>
  <div class="modal fade" tabindex="-1" role="tooltip">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-body">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="container"><slot></slot></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "modal"
  }
</script>

<style scoped>
  .modal {
    white-space: normal;
  }

  .modal button.close {
    position: absolute;
    top: 0.2em;
    right: 0.5em;
    font-size: 1.8em;
  }

  .modal .container {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
</style>